import { render, staticRenderFns } from "./UpsellGroupListItem.vue?vue&type=template&id=9008a100"
import script from "./UpsellGroupListItem.vue?vue&type=script&lang=js"
export * from "./UpsellGroupListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports